import { useRef, useEffect } from "react";
import { gsap, useGSAP } from "@/shared/lib/gsap";

import { IcoPcHomeScroll } from "@/shared/assets/icons/ico_pc_home_scroll";
import { useTranslations } from "next-intl";

interface ScrollIndicatorProps {
  show: boolean;
  onHide?: () => void;
}

export function ScrollIndicator({ show, onHide }: ScrollIndicatorProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const t = useTranslations();
  useGSAP(() => {
    if (!show || !scrollRef.current) return;

    // 초기 상태 설정
    gsap.set(scrollRef.current, { opacity: 0, y: 20 });

    // 페이드 인 애니메이션
    gsap.to(scrollRef.current, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: "power2.out",
      onComplete: () => {
        // 페이드 인 완료 후 둥둥 뜨는 애니메이션 시작
        gsap.to(scrollRef.current, {
          y: -10,
          duration: 0.5,
          ease: "power2.inOut",
          repeat: -1,
          yoyo: true,
        });
      },
    });
  }, [show]);

  // 스크롤 이벤트 감지
  useEffect(() => {
    if (!show) return;

    const handleScroll = () => {
      if (window.scrollY > 50) {
        // 50px 이상 스크롤하면 숨기기
        onHide?.();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [show, onHide]);

  if (!show) return null;

  return (
    <div ref={scrollRef} className="absolute bottom-11 left-1/2 flex -translate-x-1/2 flex-col items-center text-white">
      <span className="body-sm-medium">{t("mn_ban_btn_scr")}</span>
      <IcoPcHomeScroll />
    </div>
  );
}
